// https://app.growthbook.io/features/pen-5891_v1
export const EMAIL_CAPTURE_IN_PROMO_MODAL_FLAG_NAME = 'pen-5891_v1'
